const SubscriptionQueryKeys = {
  global: ["subscriptions"] as const,
  list: () => [...SubscriptionQueryKeys.global, "list"] as const,
};

const SubscriptionPlanQueryKeys = {
  global: ["subscriptionPlans"] as const,
  list: () => [...SubscriptionPlanQueryKeys.global, "list"] as const,
};

const SubscriptionPaymentQueryKeys = {
  global: ["subscriptionPayments"] as const,
  list: () => [...SubscriptionPaymentQueryKeys.global, "list"] as const,
};

const SubscriptionPaymentCardQueryKeys = {
  global: ["subscriptionPaymentCards"] as const,
  list: () => [...SubscriptionPaymentCardQueryKeys.global, "list"] as const,
};

export {
  SubscriptionQueryKeys,
  SubscriptionPlanQueryKeys,
  SubscriptionPaymentQueryKeys,
  SubscriptionPaymentCardQueryKeys,
};
